import React, { Component } from 'react';
import { base, firebaseAuth } from '../../../config/constants';
import { Button, Image, Form, Input, Grid } from 'semantic-ui-react'
import * as UiConsts from '../../../config/UiConstants'
import OrderCard from '../../dashBoard/newDashboard/OrderCard';
import Status from '../../../config/OrderStatusConstants'

class CountryViews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            imageUrl: '',
            orderNumber: '',
            loadingUser: true,
            loading: false,
            orderFound: '',
            order: [],
            deliveryPeople: [],
            orderNotFound: false,
            country: ''
        }
    }

    componentDidMount() {
        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                //console.log("user is signed in:" + user.uid);
                this.setState({
                    user: user,
                    loadingUser: false,
                    country: this.props.match.params.country
                })

                this.loadOrders(this.props.match.params.country);

            } else {
                console.log("user is NOT signed in:" + user.uid);
            }

            this.setState({
                loadingUser: false
            })
        });

        //GET DELIVERY PEOPLE
        base.fetch('admin/deliveryPeople', {
            context: this,
            asArray: true,
            then(data) {
                // console.log(data);
                this.setState({
                    deliveryPeople: data
                })
            }
        });
    }

    loadOrders = (country) => {
        console.log("+++++++: load country");
        console.log("country:" + country);

        this.setState({
            loading: true,
            country: country
        })

        
        //SNYC ORDER
        base.syncState('orders', {
            context: this,
            asArray: true,
            state: 'order',
            queries: {
                orderByChild: 'country',
                equalTo: country
            },
            then(data) {
               // console.log("dancing done:" + JSON.stringify(this.state.order, null, 2));
                this.setState({
                    loading: false
                })
            }
        });
        //parseInt(this.state.orderNumber)
    }

    render() {

        const orderUI = this.state.order.map((order) =>
            <Grid.Column>
                <OrderCard
                    //user={this.state.userFromFirebaseNode}
                    user={this.state.user}
                    order={order}
                    deliveryPeople={this.state.deliveryPeople} />
            </Grid.Column>
        )

        const loadingImage = this.state.loading === true
            ? <UiConsts.LoadingComponent />
            : <div>
                <Grid stackable columns={3}>
                    {orderUI}
                </Grid>

            </div>


        return (this.state.loadingUser === true ? <UiConsts.LoadingComponent /> :
            <div>
                <h1>STATUS - {this.props.match.params.status}</h1>
                <h1>NUM ORDERS - {this.state.order.length}</h1>
                <br />

                {loadingImage}
                {/* <h2>imageUrls:{this.state.imageUrl}</h2> */}

            </div>
        )
    }
}

export default CountryViews;


// WEBPACK FOOTER //
// ./src/components/newSite/StatusSpecificViews/CountryViews.js